import { getConfig } from "../configuration";

function getApiConfig() {
  const baseUrl = getConfig().apiBaseUrl == "" ? window.location.origin : getConfig().apiBaseUrl;
  return {
    baseUrl: baseUrl
  };
}

export default getApiConfig;
